var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollCon",
    staticClass: "tags-outer-scroll-con",
    on: {
      "DOMMouseScroll": _vm.handlescroll,
      "mousewheel": _vm.handlescroll
    }
  }, [_c('div', {
    staticClass: "close-all-tag-con",
    staticStyle: {
      "box-shadow": "0 0px 0px #ccc !important"
    }
  }, [_c('Dropdown', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-click": _vm.handleTagsOption
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "plain": "",
      "type": "primary"
    }
  }, [_vm._v("\n        更多\n        "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "clearAll"
    }
  }, [_vm._v("关闭所有")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "clearOthers"
    }
  }, [_vm._v("关闭其他")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "scrollBody",
    staticClass: "tags-inner-scroll-body",
    style: ({
      left: _vm.tagBodyLeft + 'px'
    })
  }, [_c('transition-group', {
    attrs: {
      "name": "taglist-moving-animation"
    }
  }, _vm._l((_vm.pageTagsList), function(item, index) {
    return _c('Tag', {
      key: item.name,
      ref: "tagsPageOpened",
      refInFor: true,
      attrs: {
        "type": "dot",
        "name": item.name,
        "closable": item.name === 'home_index' ? false : true,
        "color": item.children ? (item.children[0].name === _vm.currentPageName ? 'blue' : 'default') : (item.name === _vm.currentPageName ? 'blue' : 'default')
      },
      on: {
        "on-close": _vm.closePage
      },
      nativeOn: {
        "click": function($event) {
          return _vm.linkTo(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.itemTitle(item)) + "\n      ")])
  }), 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6728713e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/TagsOpened.vue
// module id = QXY6
// module chunks = 166